import defaultClient from '@src/api/clients/default';

const URL = (path) => {
  return `dashboard/ad-summary/${path}/`;
};

export function fetchAdSummaryByAd(payload = {}) {
  return defaultClient.request({
    url: URL('ad'),
    payload,
  });
}

export function fetchAdSummaryByTheme(payload = {}) {
  return defaultClient.request({
    url: URL('theme'),
    payload,
  });
}

export function fetchAdSummaryBySubtheme(payload = {}) {
  return defaultClient.request({
    url: URL('subtheme'),
    payload,
  });
}

export function fetchAdSummaryFilterOptions(payload = {}) {
  return defaultClient.request({
    url: URL('filter-options'),
    payload,
  });
}

export function pauseAdSummaryAd(payload = {}) {
  return defaultClient.request({
    url: URL('pause-ad'),
    method: 'POST',
    payload,
  });
}
